<!--
  2022-09-24 Matt 显示第3方的页面，比如展示第三方活动页等等
-->
<template>
  <div class="iFrame3Part">
    <div class="cancel">
      <img :src="cancel" alt="" @click="close">
    </div>
    <div class="iframeContainer">
      <iframe
        ref="iframe"
        :src="iFrameSrc" sandbox="allow-top-navigation allow-scripts allow-popups allow-forms allow-pointer-lock allow-same-origin"
      >
      </iframe>
    </div>
  </div>
</template>

<script>
import cancel from '@/assets/images/common/cancel.svg'

export default {
  name: 'GameIframe',
  props: {
    'iFrameSrc': String,
    'handelClose': Function
  },
  data () {
    return {
      cancel,
      isLoading: false
    }
  },
  mounted () {
    const iframe = this.$refs.iframe
    iframe.onload = () => {
      this.isLoading = false
    }
  },
  methods: {
    close () {
      this.handelClose()
    }
  }
}
</script>

<style lang="less" scoped>
  .iFrame3Part {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 150;
    background-color: rgba(0,0,0,.9);

    .cancel {
      position: fixed;
      top: 10px;
      right: 20px;
    }

    .iframeContainer {
      padding: 50px 0 30px 0;

      iframe {
        width: 100vw;
        height: 100vh;
        padding-bottom: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/IFrame3Part/index.vue